var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgWarningFill = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  fillRule: "evenodd",
  d: "M11.82 1.105c-5.912 0-10.715 4.763-10.715 10.65s4.803 10.65 10.715 10.65 10.715-4.763 10.715-10.65-4.803-10.65-10.715-10.65M12.83 7.3a1 1 0 1 0-2 0v5.4a1 1 0 1 0 2 0zm-1 7.4a1.2 1.2 0 1 0 0 2.4 1.2 1.2 0 0 0 0-2.4",
  clipRule: "evenodd"
})));
export default SvgWarningFill;